import React, { useState, useEffect } from 'react';
import { SlidersHorizontal } from 'lucide-react';

const FloatingFilterButton = ({ onClick, hasActiveFilters, activeCount = 0 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={onClick}
      className="md:hidden fixed bottom-52 right-4 z-40 flex items-center gap-2 px-4 py-3 bg-hoi-blue text-white shadow-lg hover:bg-hoi-blue/90 transition-all animate-in fade-in slide-in-from-bottom-4 duration-300"
      style={{ borderRadius: '0px' }}
      aria-label={activeCount > 0 ? `Filters openen (${activeCount} actief)` : 'Filters openen'}
      data-testid="floating-filter-btn"
    >
      <SlidersHorizontal className="w-5 h-5" />
      <span className="text-sm font-medium">Filters</span>
      {hasActiveFilters && activeCount > 0 && (
        <span
          className="absolute -top-2 -right-2 min-w-[22px] h-[22px] px-1 bg-hoi-coral text-white text-xs font-bold rounded-full flex items-center justify-center shadow-md ring-2 ring-white"
          data-testid="floating-filter-count"
        >
          {activeCount}
        </span>
      )}
    </button>
  );
};

export default FloatingFilterButton;
